import { FormattedMessage } from 'react-intl'

import { IconHeaderTime } from 'components/Icons'
import { Card } from 'components/Layout'

import { NextSteps } from '../../NextSteps'
import type { Step, StepType } from '../../Step'
import type { UserMetadata } from '../../UserMetadata'
import { Content } from './Content'
import { Wrapper } from './Wrapper'

type Props = TaggedType<Step, StepType.MissingOtherApplicant> & {
	userMetadata: UserMetadata
}

export const MissingOtherApplicant = ({ userMetadata: { applicantType, otherApplicantName } }: Props) => (
	<Wrapper>
		<Card>
			<IconHeaderTime />
			<Content>
				<h2>
					<FormattedMessage id='flow.missingOtherApplicant.title' defaultMessage='Waiting for co-applicant' />
				</h2>
				<p>
					<FormattedMessage
						id='flow.missingOtherApplicant.description'
						defaultMessage='Before you can finalize the budget, {otherApplicantName} must first submit their information.'
						values={{ otherApplicantName }}
					/>
				</p>
				<p>
					<FormattedMessage
						id='flow.missingOtherApplicant.description2'
						defaultMessage='Once this is done, you must finalize the budget together.'
					/>
				</p>
			</Content>
		</Card>
		<NextSteps applicantType={applicantType} otherApplicantName={otherApplicantName} completedStep='signup' />
	</Wrapper>
)
